module.exports = __webpack_public_path__ + "img/6.c1ec092e.png";